import {
  Box,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Paper,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SC from "styled-components";
import { theme } from "../../Customization/Theme";

import AppIcon from "../../AppComponents/AppIcon";
import AppUserDropdown from "../../AppComponents/AppUserDropdown";
import { AppTitle } from "../../Customization/CommonElements";
import { topUserMenuOptions } from "../../Models/defaultSelectOptions";
import { CoreService } from "../../Services/Apis/CoreApis";
import { refreshAccessToken, useAuthStore } from "../../Store/Slices/AuthSlice";

import { ProtectedAppButton } from "../../AppComponents/ProtectedComponents";
import { ReactComponent as UserAvatar } from "../../assets/images/useravatar.svg";
import { ReactComponent as WalletImage } from "../../assets/images/wallet.svg";
import {
  HocBackdropLoader,
  HocBackdropLoaderProps,
} from "../../HOC/HocBackdropLoader";
import { useAppDispatch, useAppSelector } from "../../Store";
import {
  setIsUserAvailable,
  setUserCreditsInfo,
  useCurrentUser,
} from "../../Store/Slices/CurrentUser/CurrentUserSlice";
import { SubscriptionsNetworkService } from "../../Store/Slices/Subscriptions/subscriptionsNetworkService";
import AddWallet from "./AddWallet";
import { Wallet } from "./MenuStyle";
import { AppToolTip } from "../UiComponents/AppToolTip/AppToolTip";
import { AppMaterialIcons } from "../../AppComponents/AppMaterialIcons";
import { ChatbotConsoleService } from "../../Services/Apis/ChatbotConsoleService";
import { useNotification } from "../../Hooks/useNotification/useNotification";
import { useSocket } from "../../socket/hooks/socket-context";
import { SOCKET_CONNECTION_TYPES } from "../../socket/utils/Enum";
import AppInfoHelpTooltip from "../../AppComponents/Forms/AppInfoHelpTooltip";
import { getWhatsappHealthStatusClass } from "../../Utils";
import { useTopBarNotification } from "./useTopBarNotification";
import CloseIcon from "@mui/icons-material/Close";
import { NotificationBarContainer } from "./notification-bar";
import { NovuNotification } from "../../AppComponents/Notification";
import getPublicAssets from "../../Services/s3bucket";
import { ApidomainDetails, domainDetails } from "../../Store/Slices/SubAccount/subaccount.selectors";
import useLiveChatNewSessions from "../../Hooks/useLivechatNewSessions";
import { getDeviceInfo } from "../../Utils/device-details";
import { UPGRADE_BUTTON_HIDDEN_WORKSPACE_IDS } from "../Subscription/Expired/ExpireSubscription";

let notificationSound: any = new Audio(require("../../../src/assets/tong.mp3"));
const logo = getPublicAssets("icons/wabo_circle_v2.svg");

interface TopMenuProps extends HocBackdropLoaderProps {
  fullWidth?: any;
  showLogo?: boolean;
  theme?: any;
}
interface Window {
  EasebuzzCheckout?: any; // Replace 'any' with the specific type if available
}

const TopMenu = (props: TopMenuProps) => {
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(true);
  const { data: authData } = useSelector(useAuthStore);
  const { userConfig } = useSelector(useAuthStore);
  const { isUserAvailable } = useAppSelector(useCurrentUser);
  const dispatch = useAppDispatch();
  const { userCreditsInfo } = useAppSelector(useCurrentUser);
  const [check, setCheck] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { showAlert } = useNotification();
  const domainDetailsData: any = useAppSelector(domainDetails);
  const domainApiSuccess: any = useAppSelector(ApidomainDetails);
  // const currentBot = useAppSelector(useCurrentBot);
  const { socket } = useSocket();

  useLiveChatNewSessions();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    props.setLoading(false);
    CoreService.getCredits().then((response) => {
      const reversedItems = response?.data;
      dispatch(setUserCreditsInfo(reversedItems));
    });

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const redirectToHome = () => {
    const url = "/";
    navigate(url);
  };

  const addBalance = (balance: number) => {
    props.setLoading(true);
    setCheck(false);
    let data = {
      subscription_id: userConfig?.payload?.subscription_id,
      addons: [
        {
          addon_code: "wallet-whatsapp",
          quantity: balance,
        },
      ],
      redirect_url: "/subscription/success",
    };
    if (userConfig?.payload?.sub_account_type === "reseller") {
      const easebuzzCheckout = new (window as any).EasebuzzCheckout(
        process.env.REACT_APP_PAYMENT_KEY,
        "prod"
      ); // for test enviroment pass "test"
      let data: any = {
        amount: 1,

        // amount: 1,
        success_url: window.location.href,
        failure_url: window.location.href,
        paymentGetway: "easebuzz",
      };
      SubscriptionsNetworkService.initiatePayment(data)
        .then((res: any) => {
          props.setLoading(true);
          var options = {
            access_key: res.data.data, // access key received via Initiate Payment
            onResponse: (response: any) => {
              if (response.success === false || response.status !== "success") {
                showAlert(`Transaction of INR ${balance} failed`, "error");
                props.setLoading(false);
              } else {
                props.setLoading(true);
                setTimeout(() => {
                  CoreService.getCredits().then((response) => {
                    const reversedItems = response?.data;
                    dispatch(setUserCreditsInfo(reversedItems));
                    // props?.getCreditsData(reversedItems);
                    props.setLoading(false);
                    showAlert(
                      `Credits of ${balance} added successfully`,
                      "success"
                    );
                  });
                }, 5000);
              }
              // props.setLoading(false);

              // CoreService.getCredits().then((response) => {
              //   debugger;
              //   const reversedItems = response?.data;
              //   dispatch(setUserCreditsInfo(reversedItems));
              //   // props?.getCreditsData(reversedItems);
              // });
            },
            theme: "##ff0000", // color hex
          };
          easebuzzCheckout.initiatePayment(options);
        })
        .catch((err: any) => {
          // props.setIsLoading(false)
          props.setLoading(false);
        });
      return;
    }

    if (userConfig?.payload?.sub_account_type === "user") {
      SubscriptionsNetworkService.addCredits(
        data,
        userConfig?.payload?.subscription_id
      )
        .then((res: any) => {
          window.open(res?.data?.hostedpage?.url, "_self");
        })
        .catch((err: any) => {
          props.setLoading(false);
        })
        .finally(() => {
          props.setLoading(false);
        });
      return;
    }
  };
  const getNotificationMessage = (name: any, paylaod: any) => {
    if (name === "task") {
      return { name: "Task Reminder", url: "/task/lists/" + paylaod?.task_id };
    } else if (name === "task-assigned") {
      return { name: "Task Assigned", url: "/task/lists/" + paylaod?.task_id };
    } else if (name === "task-ontime") {
      return { name: "Task Ontime", url: "/task/lists/" + paylaod?.task_id };
    } else if (name === "task-overdue") {
      return { name: "Task Overdue", url: "/task/lists/" + paylaod?.task_id };
    } else if (name === "export-contacts-and-logs") {
      return { name: "Export Completed", url: "/settings/data-management/export-contact-history" };
    }
    return { name: "", url: "" };
  };
  useEffect(() => {
    if (!socket) return;
    const handleUserSessions = (response: any) => {
      if (response.data) {
        notificationSound.play().catch((error: any) => {
          console.error("Failed to play notification sound:", error);
        });
        let message = response?.data?.notification_content;
        if (!("Notification" in window)) {
          alert("This browser does not support system notifications!");
        } else if (Notification.permission === "granted") {
          setTimeout(() => {
            const notification = new Notification(
              getNotificationMessage(
                response?.data?.type,
                response?.data?.paylaod
              )?.name,
              {
                icon: logo,
                body: `${message}`,
              }
            );
            showAlert(message, "success");
            notification.onclick = () => {
              window.open(
                getNotificationMessage(
                  response?.data?.type,
                  response?.data?.paylaod
                )?.url,
                "_blank"
              );
            };
          }, 1000);
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission((permission) => {
            if (permission === "granted") {
              setTimeout(() => {
                const notification = new Notification(
                  getNotificationMessage(
                    response?.data?.type,
                    response?.data?.paylaod
                  )?.name,
                  {
                    icon: logo,
                    body: `${message}`,
                  }
                );
                notification.onclick = () => {
                  window.open(
                    getNotificationMessage(
                      response?.data?.type,
                      response?.data?.paylaod
                    )?.url,
                    "_blank"
                  );
                };
              }, 1000);
            }
          });
        }

        // Toggle showNotification to re-render Notification
        setShowNotification(false);
        setTimeout(() => setShowNotification(true), 0); // Re-mount immediately
      }
    };
    socket.on("app-notification", handleUserSessions);
  }, [socket]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props?.setLoading(true);
    let payload = {
      user_id: authData?.data?.user?.id,
      workspace_id: authData?.data?.user?.workspace_id,
      online_status: event.target.checked ? true : false,
      device: getDeviceInfo(),
    };

    ChatbotConsoleService.agentOnlineStatus(payload)
      .then((res: any) => {
            socket?.emit(
              SOCKET_CONNECTION_TYPES.ONLINE_AGENTS_STATUS_CHANGED,
              payload,
              (error: any, response: any) => { },
            );
      })
      .catch((err: any) => {
        console.error("agent error", err);
      })
      .finally(() => {
        props?.setLoading(false);
      });
  };
  const redirectToPlanPage = () => {
    const url = "/subscription/subscription-plans/plans";
    navigate(url);
  };
  const { showTopBarNotification, hideTopBarNotification } =
    useTopBarNotification();

  useEffect(() => {
    if (!userConfig?.payload) return;

    const workspaceId = authData?.data?.user?.workspace_id;
    if (UPGRADE_BUTTON_HIDDEN_WORKSPACE_IDS.includes(workspaceId)) return;

    const isTrial = userConfig?.payload?.subscription_status === "trial";
    const isLive = userConfig?.payload?.subscription_status === "live";
    const isCancelled =
      userConfig?.payload?.subscription_status === "cancelled";

    const showBar = isTrial
      ? true
      : isLive && userConfig?.payload?.days_to_expire > 0 && userConfig?.payload?.days_to_expire <= 7
      ? true
      : isCancelled
      ? true
      : false;

    const text = `Your ${
      userConfig?.payload?.plan_code ?? "trial"
    } plan will expire in ${userConfig?.payload?.days_to_expire} day(s)`;

    const todayText = `Heads up! Your ${
      userConfig?.payload?.plan_code ?? "trial"
    } plan ends today.`;

    const overdueText=`Your ${
      userConfig?.payload?.plan_code ?? "trial"
    } plan expired ${userConfig?.payload?.overdue_days} day(s) ago`;

    userConfig?.payload?.overdue_days>0 &&  showTopBarNotification(
      <NotificationBarContainer $variant={"error"}>
        <p className="text">{overdueText}</p>
        <ProtectedAppButton
            moduleId="add_credits_to_wallet"
            style={{ width: "150px", margin: "0px 8px" }}
            onClick={() => {
              redirectToPlanPage();
            }}
          >
            Upgrade your plan
          </ProtectedAppButton>

          <IconButton
            className="closeButton"
            onClick={() => hideTopBarNotification()}
          >
            <CloseIcon />
          </IconButton>

      </NotificationBarContainer>
    );

    if (showBar && userConfig?.payload?.days_to_expire >= 0 && userConfig?.payload?.days_to_expire <= 10) {
      showTopBarNotification(
        <NotificationBarContainer $variant={"error"}>
          <p className="text">{userConfig?.payload?.days_to_expire>0 ? text: todayText}</p>
          <ProtectedAppButton
            moduleId="add_credits_to_wallet"
            style={{ width: "150px", margin: "0px 8px" }}
            onClick={() => {
              redirectToPlanPage();
            }}
          >
            Upgrade your plan
          </ProtectedAppButton>

          <IconButton
            className="closeButton"
            onClick={() => hideTopBarNotification()}
          >
            <CloseIcon />
          </IconButton>
        </NotificationBarContainer>
      );
    }
  }, [userConfig?.payload?.days_to_expire]); // eslint-disable-line react-hooks/exhaustive-deps

  const businessName = domainDetailsData?.name;
  const title = businessName
    ? businessName.charAt(0).toUpperCase() + businessName.slice(1)
    : "Wabo";

  return (
    <TopMenuWrap fullWidth={props.fullWidth} className="main-topbar">
      <TopMenuLeftBox>
        <AppTitle onClick={() => redirectToHome()}> {title}</AppTitle>
        {userConfig?.payload?.whatsapp_enabled ? (
          <div className="conversationLimitBox" id="whatsapp-conversation-health">
            Health:{" "}
            <div
              className={`health-status ${getWhatsappHealthStatusClass(
                userConfig?.payload?.whatasapp_config?.quality ?? "UNKNOWN"
              )}`}
            ></div>{" "}
            <AppInfoHelpTooltip
              id="health-status-tooltip-id"
              title={userConfig?.payload?.whatasapp_config?.quality}
            />{" "}
            |{" "}
            <span id="whatsapp-limit-box">
              {" "}
              &nbsp; Limit:{" "}
              <span className="subTitle">
                {" "}
                {userConfig?.payload?.whatasapp_config?.limit}{" "}
                <AppInfoHelpTooltip
                  id="limit-status-tooltip-id"
                  title={userConfig?.payload?.whatasapp_config?.limit}
                />
              </span>
            </span>
          </div>
        ) : null}
      </TopMenuLeftBox>
      <TopMenuRightBox>
        <Wallet>
          <WalletImage />
          <p>
            Balance:{" "}
            <span className="credits">
              {parseFloat(userCreditsInfo?.remaining_amounts) || 0}
            </span>
          </p>
          {!(
            userConfig?.payload?.sub_account_type === "reseller" || 
            domainApiSuccess === true
          ) && (
           <ProtectedAppButton
            moduleId="add_credits_to_wallet"
            id="top-menu_add_balance"
            style={{ width: "90px", margin: "0px 8px" }}
            onClick={() => {
              setCheck(true);
            }}
          >
            Add Balance
          </ProtectedAppButton>
        )}
        </Wallet>
        {showNotification && <NovuNotification/>}
        <div>
          <div
            style={{
              padding: "8px 1rem",
              overflow: "hidden",
              display: "flex",
            }}
          >
            <FormControlLabel
              control={
                <CustomSwitch
                  checked={isUserAvailable}
                  onChange={handleChange}
                  name="userOnline"
                  size="small"
                />
              }
              label={""}
            />
            <FormHelperText
              style={{
                fontSize: "16px",
                margin: "3px -4px 2px",
                width: "68px", //added to skip layout shift
              }}
            >
              {isUserAvailable ? "Available" : " Away "}
            </FormHelperText>
            <AppToolTip
              tooltipProps={{
                title:
                  "When set to 'Offline', no chats will be assigned. Toggle to 'Available' to start receiving chats again",
                placement: "top",
              }}
              id="online-status-tooltip"
              IconComponent={
                <AppMaterialIcons
                  iconName="HelpOutline"
                  style={{ fontSize: "16px" }}
                />
              }
            />
          </div>
        </div>
        <div
          onClick={(e) => handleClick(e)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow:
                "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          >
            <UserAvatar />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="6px"
          >
            <Typography variant="subtitle1">
              {authData &&
                authData.data &&
                authData.data.user &&
                authData.data.user.first_name}
            </Typography>
            <AppIcon
              size="22px"
              color={theme.palette.default.darkGrey}
              title="ri-arrow-down-s-line"
            />
          </Box>
        </div>
      </TopMenuRightBox>

      <AppUserDropdown
        open={open}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        data={topUserMenuOptions}
      />
      <AddWallet check={check} setCheck={setCheck} addBalance={addBalance} />
    </TopMenuWrap>
  );
};

export default HocBackdropLoader(TopMenu);
const TrialText = SC.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  justify-content: center;
`;
const TopMenuLeftBox = SC.div`
  && {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 4;
    img {
      cursor: pointer;
    }
    p {
      cursor: pointer;
    }

    .conversationLimitBox {
      color: ${theme.palette.default.text};
      font-weight: 500;
      font-size: 14px;
      margin-left: 2rem;
      display: flex;
      align-items: center;
      .subTitle {
        color: ${theme.palette.default.darkGrey};
      }
    }

    .health-status {
      display: inline-flex;
      margin-left: 4px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }
    .success {
      background-color: ${theme.palette.default.success};
    }
    .error {
      background-color: ${theme.palette.default.error};
    }
    .unknown {
      background-color: ${theme.palette.default.darkGrey};
    }
  }
`;
const TopMenuRightBox = SC.div`
  && {
    display: flex;
    justify-content: right;
    gap: 0.5rem;
    align-items: center;

    .conversationLimitBox {
      color: ${theme.palette.default.darkGrey};
      font-weight: 400;
      font-size: 14px;
      margin-left: 1rem;
    }
  }
`;

export const UserMenuBox = styled(Paper)`
  && {
    position: absolute;
    top: 100%;
    right: 2%;
  }
`;

export const TopMenuWrap = SC.div<TopMenuProps>`
  && {
    background-color: ${theme.palette.default.white};
    z-index: 999;
    height: 4rem;
    width: ${(props: any) => (props?.fullWidth ? `100%` : "calc(100% - 60px)")};
    padding: 0 1rem;
    position: -webkit-fixed;
    position: fixed;
    right: 0;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
  }
`;

const CustomSwitch = styled(Switch)(({ theme }: any) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",

  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 4,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#FFFFFF",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#008000",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 8,
    height: 8,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
  "& .MuiFormControlLabel-root": {
    marginLeft: "-4px",
  },
}));
